import { gql } from '@apollo/client'
import React from 'react'

import { accountsClient } from '../../../../utils/apollo/api'
import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../packages/kiti/components/helpers/LazyAction'
import Separator from '../../../../packages/kiti/components/helpers/Separator'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useProjectsState = () => React.useContext(Context)
export const useProjects = () => useProjectsState()?.projects

const QUERY = gql`
  query Projects($page: Int) {
    projects(page: $page, sort: { field: ID, type: ASC }) {
      id
      name
      color
      icon
      createdById
    }
  }
`

const ProjectsListLoader = ({ children }) => {
  const { data, fetchMore, ...state } = usePaginatedQuery(QUERY, {
    client: accountsClient,
    fetchPolicy: 'cache-first',
    variables: {
      page: 1
    }
  })

  return (
    <StatePresenter {...state} empty={false}>
      <Provider value={data}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading} />
        <Separator usePadding weight={12} />
      </Provider>
    </StatePresenter>
  )
}

export default ProjectsListLoader
